import { Button, Card, Flex, Heading, Text, TextField } from "@radix-ui/themes";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../store";
import { login } from "../../../store/slices/authSlice";

export function StaffLogin({
  onAuthenticated,
  onCancel,
}: {
  onAuthenticated: () => void;
  onCancel: () => void;
}) {
  const dispatch = useAppDispatch();
  const pending = useAppSelector((state) => state.auth.loading === "pending");
  const [error, setError] = useState<string | null>(null);

  return (
    <main className="h-dvh bg-gray-2 flex items-center justify-center p-6">
      <Card className="w-full max-w-[440px] !p-7 shadow-xl">
        <form
          autoComplete="off"
          onSubmit={async (event) => {
            event.preventDefault();
            setError(null);
            const form = event.currentTarget;
            const data = new FormData(form);
            const username = String(data.get("kiosk-staff-username") ?? "");
            const password = String(data.get("kiosk-staff-password") ?? "");
            if (!username || !password) return;

            try {
              await dispatch(login({ username, password })).unwrap();
              form.reset();
              onAuthenticated();
            } catch {
              form.reset();
              setError(
                "Sign-in failed or this account cannot configure this kiosk.",
              );
            }
          }}
        >
          <Heading mb="2">Staff access</Heading>
          <Text as="p" color="gray" mb="5">
            Sign in with an account authorized for this kiosk's store.
          </Text>
          <Text asChild size="2" weight="medium">
            <label htmlFor="kiosk-staff-username">Username</label>
          </Text>
          <TextField.Root
            size="3"
            mt="1"
            mb="4"
            id="kiosk-staff-username"
            name="kiosk-staff-username"
            autoComplete="off"
            autoCapitalize="none"
            spellCheck={false}
          />
          <Text asChild size="2" weight="medium">
            <label htmlFor="kiosk-staff-password">Password</label>
          </Text>
          <TextField.Root
            size="3"
            mt="1"
            id="kiosk-staff-password"
            name="kiosk-staff-password"
            type="password"
            autoComplete="new-password"
          />
          {error && (
            <Text as="p" color="red" size="2" mt="3" role="alert">
              {error}
            </Text>
          )}
          <Flex gap="3" mt="6">
            <Button
              className="!basis-[calc(50%-0.375rem)]"
              size="4"
              type="button"
              variant="soft"
              color="gray"
              onClick={onCancel}
            >
              Cancel
            </Button>
            <Button
              className="!basis-[calc(50%-0.375rem)]"
              size="4"
              type="submit"
              loading={pending}
            >
              Sign in
            </Button>
          </Flex>
        </form>
      </Card>
    </main>
  );
}
